export const max_pretty_render = 4;

interface NestedParentItem {
  name: string;
  parent?: NestedParentItem | null;
}

export const ParentPrettyRender = (
  item: NestedParentItem | null,
  depth: number | null = null
): string => {
  if (item == null) return "~";

  if (depth == null) {
    return ParentPrettyRender(item, max_pretty_render);
  } else if (depth > 0) {
    if (item.parent)
      return item.name + " < " + ParentPrettyRender(item.parent, depth - 1);
    else return item.name;
  }

  return item.name;
};
